import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from './actions'
import * as routes from '../../../routes/const'

import Header from '../../../components/layouts/Header'

import {
  NitroHeading,
  NitroLoading,
  NitroNavBar,
  NitroGrids,
  NitroButtonGroup,
  NitroButton,
  NitroPlaceholder,
  NitroSingleSelect,
} from 'nitro-components'

import { NitroPanel, NitroDivider } from 'nitro-components/build/nitro'
import { media } from 'style-utils'

import {
  FilterSection,
  CountryFilter,
  CostcenterFilter,
} from '../../../components/filter'
import DisableCover from '../../../components/libs/disabled'
import { getQuoteCreationCCAndCountry } from './selector'

import CostcentreApi from '../../../api/CostcentreApi'

const NextButtonWrapper = styled.div`
  margin-left: auto;
  ${media.mobile`margin-left: 0;`};
`

class QuoteSource extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      fetchingRestrictions: false,
      selectedResCostCenter: null,
      costCenterOptions: [],
    }
  }

  componentDidMount() {
    const { country, costcenter } = this.props

    this.props.actions.setCountry(country)
    this.props.actions.setCostCenter(costcenter)
    this.getCompanyDynamicFilters(country.value, costcenter.value)
    this.forceUpdate()
  }

  onSourceChange = (idx, newFilter) => {
    console.log('source change', idx, newFilter)
    switch (idx) {
      case 0:
        this.props.actions.setCountry(newFilter)
        break
      case 1:
        this.props.actions.setCostCenter(newFilter)
        this.getCompanyDynamicFilters(this.props.country.value, newFilter.value)
        break
    }
  }

  selectResCostCenter = resCCVal => {
    this.setState({
      selectedResCostCenter: resCCVal.value,
    })
    this.props.actions.setResCostCenter(resCCVal)
  }

  submitAction = () => {
    const { router } = this.context
    router.push(routes.CQ_CREATE_VEHICLE)
  }

  getCompanyDynamicFilters(countryCode, companyCode) {
    const costCentreResType = 1

    this.props.actions.setResCostCenter(null)
    this.setState({
      fetchingRestrictions: true,
      selectedResCostCenter: null,
    })

    CostcentreApi.getCompanyRestrictionFilters(
      countryCode,
      companyCode,
      costCentreResType
    ).then(data => {
      let ccOpts = []
      if (data && data[0]) {
        ccOpts = data[0].options.map(item => item)
      }

      this.setState({
        fetchingRestrictions: false,
        costCenterOptions: ccOpts,
      })
    })
  }

  render() {
    const { country, costcenter } = this.props
    const {
      fetchingRestrictions,
      costCenterOptions,
      selectedResCostCenter,
    } = this.state

    const answerData = this.props.answers

    const filters = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter,
      },
      {
        title: 'Company code',
        label: costcenter.label,
        value: costcenter.value,
        component: CostcenterFilter,
      },
    ]

    return (
      <section>
        <Header margin="32px 0" lineHeight={32}>
          {answerData.length ? (
            <NitroNavBar
              actionOnHeading
              label="Back to questions"
              action={() =>
                this.context.router.push(routes.CQ_CREATE_QUESTIONS)
              }
              inline
              noPadding
              float
              lineHeight={26}
            />
          ) : null}
          <NitroHeading label="Select a cost center" size="1" align="center" />
        </Header>

        <NitroPanel>
          {filters.map((filter, index) => (
            <FilterSection
              filters={filters}
              action={this.onSourceChange}
              key={index}
              index={index}
            />
          ))}

          <NitroPlaceholder size={20} />

          {costCenterOptions &&
            costCenterOptions.length > 0 && (
              <div>
                <NitroHeading size="3" label="Cost centre" margin="8" />
                <NitroSingleSelect
                  placeholder="Select cost centre"
                  action={this.selectResCostCenter}
                  value={selectedResCostCenter}
                  options={costCenterOptions}
                />
                <NitroPlaceholder size={20} />
              </div>
            )}

          <NitroDivider />

          <NitroButtonGroup layout="horizontal">
            <NextButtonWrapper>
              <NitroButton
                block
                size="small"
                label="Next"
                variant="primary"
                action={this.submitAction}
              />
            </NextButtonWrapper>
          </NitroButtonGroup>

          {fetchingRestrictions && (
            <div>
              <DisableCover />
              <NitroLoading position="center" size={30} />
            </div>
          )}
        </NitroPanel>
      </section>
    )
  }
}

QuoteSource.propTypes = {
  actions: PropTypes.object.isRequired,
}

QuoteSource.contextTypes = {
  router: PropTypes.object,
}

const mapStateToProps = state => {
  const { create } = state.corporateQuote

  return {
    answers: create.answers,
    ...getQuoteCreationCCAndCountry(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuoteSource)



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteSource.js